// Global
import React from 'react';
import clsx from 'clsx';

// Local
import styles from './ProductHeroDecor.module.scss';
import { useIsMobile } from 'lib/hooks/useIsMobile';

export const ProductHeroDecor = () => {
  const isMobile = useIsMobile();

  return (
    <div className={clsx(styles.decorWrapper)}>
      <svg
        className={clsx(styles.decorStyleBettyCrocker, styles.decorColor)}
        xmlns="http://www.w3.org/2000/svg"
        width={isMobile ? '400' : '1400'}
        height={isMobile ? '68' : '129'}
        viewBox={isMobile ? '0 0 400 68' : '0 0 1400 129'}
        fill="none"
      >
        {isMobile ? (
          <path
            d="M0 14C0 14 62.7778 57.5 200.972 57.5C339.167 57.5 400 14 400 14V78H200H0V14Z"
            fill="currentColor"
          />
        ) : (
          <path
            d="M0 0C0 0 219.722 123.871 703.403 123.871C1187.08 123.871 1400 0 1400 0V150H700H0V0Z"
            fill="currentColor"
          />
        )}
      </svg>
    </div>
  );
};
